import TotalTable from './TotalTable'

export * from './TotalTable'
export default TotalTable
